import {
  IRequirementResponse,
  PayeeTaxDocumentSharePermission,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { WSQueryClient } from "../../../query/helpers";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_LIST
} from "../../../query/requirements/keys";

/**
 * Updates cached tax verification requirements after W9 consent is given
 * Uses QueryClient.getQueriesData to find and update ALL cached requirement lists
 * @param payerIds - Payer IDs that now have consent
 */
export function updateTaxVerificationRequirementCaches(payerIds: string[]) {
  const payerIdSet = new Set(payerIds);

  // Helper to update a single requirement if it matches criteria
  const updateRequirement = (
    req: IRequirementResponse
  ): IRequirementResponse => {
    // Only update TaxVerification requirements for specified payers
    if (
      req.requirementType === RequirementType.TaxVerification &&
      payerIdSet.has(req.payerId)
    ) {
      return {
        ...req,
        dataSourceMetadata: {
          ...req.dataSourceMetadata,
          payeeOwnedData: {
            ...req.dataSourceMetadata?.payeeOwnedData,
            shareTaxDocument: PayeeTaxDocumentSharePermission.Allow
          }
        }
      };
    }
    return req;
  };

  // Update all QUERY_REQUIREMENTS_FULL_LIST caches
  // getQueriesData returns [[queryKey, data], ...] for all queries matching the predicate
  const fullListQueries = WSQueryClient.getQueriesData<IRequirementResponse[]>({
    queryKey: [QUERY_REQUIREMENTS_FULL_LIST],
    exact: false // Match all queries starting with this key
  });

  fullListQueries.forEach(([queryKey, data]) => {
    if (data && Array.isArray(data)) {
      const updated = data.map(updateRequirement);
      WSQueryClient.setQueryData(queryKey, updated);
    }
  });

  // Update all QUERY_REQUIREMENTS_LIST caches (paginated/infinite scroll)
  const listQueries = WSQueryClient.getQueriesData<IRequirementResponse[]>({
    queryKey: [QUERY_REQUIREMENTS_LIST],
    exact: false
  });

  listQueries.forEach(([queryKey, data]) => {
    if (data && Array.isArray(data)) {
      const updated = data.map(updateRequirement);
      WSQueryClient.setQueryData(queryKey, updated);
    }
  });
}
